import { IObjectStore } from '@shared/service/Indexeddb/IObjectStore';
import { IFrameStore } from '@rift/service/validation/database/syncrecording/IFrameStore';

export interface IDatabaseCountFramesStore extends IFrameStore {
}

export class DatabaseCountFramesStore implements IObjectStore {
    public static readonly keyPath: string = 'id';
    public static readonly recordingIdBlockIndex: string = 'RecordingIdBlockIndex';
    public static readonly recordingIdFrameNumberIndex: string = 'RecordingIdFrameNumberIndex';
    public static readonly recordingIdIndex: string = 'RecordingIdIndex';
    public static readonly storeDisplayName: string = 'Counts';
    public static readonly storeName: string = 'count';

    public get storeName(): string {
        return DatabaseCountFramesStore.storeName;
    };

    public static toInterface(): IDatabaseCountFramesStore {
        return {
            storeName: this.storeName,
            keyPath: this.keyPath,
            recordingIdFrameNumberIndex: this.recordingIdFrameNumberIndex,
            recordingIdIndex: this.recordingIdIndex,
            recordingIdBlockIndex: this.recordingIdBlockIndex,
        } as IDatabaseCountFramesStore;
    }

    public createStores(db: IDBDatabase): void {
        const store: IDBObjectStore = db.createObjectStore(DatabaseCountFramesStore.storeName, { keyPath: DatabaseCountFramesStore.keyPath, autoIncrement: true });
        store.createIndex(DatabaseCountFramesStore.recordingIdFrameNumberIndex, ['recordingId', 'frameNumber'], { unique: true });
        store.createIndex(DatabaseCountFramesStore.recordingIdBlockIndex, ['recordingId', 'block']);
        store.createIndex(DatabaseCountFramesStore.recordingIdIndex, 'recordingId');
    }
}
